import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import * as Sentry from "@sentry/react";
import { bootLang, loadLang } from "@/i18n";
import { isAgencyHost } from "@/lib/host";

if (process.env.REACT_APP_SENTRY_DSN) Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN, environment: process.env.REACT_APP_SENTRY_ENV || "production", tracesSampleRate: 0 });

// Load the UI language before the app's modules run, so module-level t("…") labels are translated.
const lang = bootLang({ agencyHost: isAgencyHost });
if (lang) {
  loadLang(lang)
    .then(() => import("@/App"))
    .then(({ default: App }) => {
      const root = ReactDOM.createRoot(document.getElementById("root"));
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>,
      );
    });
}
